var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "필드명"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.term,
      callback: function ($$v) {
        _vm.$set(_vm.form, "term", $$v);
      },
      expression: "form.term"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _vm.form.side == _vm.EMPLOYMENT_FIELD_SIDES.DOCUMENT.value ? [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "type": "date",
      "label": "필드값"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.data,
      callback: function ($$v) {
        _vm.$set(_vm.form, "data", $$v);
      },
      expression: "form.data"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)] : [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-switch', _vm._b({
    staticClass: "mx-2",
    attrs: {
      "label": "필수여부"
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.form.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isRequired", $$v);
      },
      expression: "form.isRequired"
    }
  }, 'v-switch', _vm.attrs_switch, false))], 1)]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }